import { Box, Typography, styled, Grid, useMediaQuery } from "@mui/material";
import color from "../../components/utils/Colors";
import { useEffect, useState } from "react";
import { getDataFromTable, getOneDataFromTable } from "../../services/services";
import { useUser } from "../../services/Context/UserContext";

const BankDetails = () => {
  const { user } = useUser();
  const [data, setData] = useState<any>(null);
  const isSmallScreen2 = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    const fetchAddress = async () => {
      if (!user?.id) return;

      try {
        const bankRes = await getDataFromTable("bankDetails", {
          userId: user.id,
        });

        const d = bankRes?.data?.data ?? bankRes?.data ?? bankRes;

        const bankData = Array.isArray(d) ? d[0] : d;

        setData(bankData);
      } catch (err) {
        console.error("Error fetching address:", err);
      }
    };

    fetchAddress();
  }, [user?.id]);

  const CustomTypo = styled(Typography)({
    color: color.textColor,
    fontSize: isSmallScreen2 ? "13px" : "20px",
    width: isSmallScreen2 ? "53%" : "30%",
    fontWeight: "bold",
    marginTop: "10px",
  });

  const CustomTypo1 = styled(Typography)({
    color: color.textColor,
    fontSize: isSmallScreen2 ? "13px" : "20px",
    width: isSmallScreen2 ? "43%" : "75%",
    marginTop: "10px",
    overflow: "auto",
    whiteSpace: "nowrap",
    display: "block",
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: color.secondColor,
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: color.firstColor,
      border: "solid 1px white",
      borderRadius: "10px",
    },
  });

  return (
    <>
      <Box
        sx={(theme) => ({
          marginTop: "25px",
          flex: 1,
          p: "3%",
          borderRadius: "16px",
          boxShadow: 2,
          bgcolor:
            theme.palette.mode === "light" ? "#faecfa71" : "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(2px)",
        })}
      >
        <Grid
          container
          spacing={2}
          sx={{ py: 1, pl: isSmallScreen2 ? 1 : 4, pb: 2 }}
        >
          <Grid item xs={12} sx={{ height: "fit-content" }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
              <CustomTypo>Account Holder Name :</CustomTypo>
              <CustomTypo1>{data?.accountHolderName ?? "—"}</CustomTypo1>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
              <CustomTypo>Bank Name :</CustomTypo>
              <CustomTypo1>{data?.bankName ?? "—"}</CustomTypo1>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
              <CustomTypo>Account Number :</CustomTypo>
              <CustomTypo1>{data?.accountNumber ?? "—"}</CustomTypo1>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
              <CustomTypo>IFSC Code :</CustomTypo>
              <CustomTypo1>{data?.IFSC ?? "—"}</CustomTypo1>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default BankDetails;
